import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  collection,
  doc,
  setDoc,
  updateDoc,
  getDoc,
  getDocs,
  query,
  where,
  addDoc,
  arrayUnion,
} from "firebase/firestore";
import moment from "moment";
import dayjs from "dayjs";
import { auth, db } from "../../../firebase";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import Footer from "../../../components/common/Footer";
import PageHeading from "../../../components/common/PageHeading";
import { toast } from "react-hot-toast";
const dateFormat = "YYYY-MM-DD";
const NewActivity = () => {
  let { id } = useParams();
  const [loadFrom, setLoadForm] = useState(false);
  const [activityData, setActivityData] = useState({});
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [allUsersData, setAllUsersData] = useState([]);
  const [isWait, setIsWait] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const editParam = queryParams.get("edit");

  const { TextArea } = Input;
  const activityId = localStorage.getItem("id");
  const handleNewActivity = () => {
    navigate(`/property-tabs/property/${id}`);
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  // editParam >=0 && toast.success(editParam);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const querySnapshot = await getDocs(usersRef);
      const matchedUser = querySnapshot.docs.find(
        (doc) => doc.data().uid === user?.uid
      );
      if (matchedUser) {
        const { companyName } = matchedUser.data();
        setCompanyName(companyName);
      }
      // setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };

  useEffect(() => {
    if (companyName) {
      const fetchUserList = async () => {
        try {
          const userRef = collection(db, "companies", companyName, "users");
          const snapshot = await getDocs(userRef);
          let fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label:
              doc.data().profile.firstName + " " + doc.data().profile.lastName,
            ...doc.data(),
          }));

          setAllUsersData(fetchedData);
        } catch (err) {
          console.error(err);
          // alert(err.message);
          toast.error(err.message)
        }
      };
      fetchUserList();
    }
  }, [companyName]);

  const onFinish = async (fieldsValue) => {
    setIsWait(true);
    const values = {
      ...fieldsValue,
      activityDate: fieldsValue["activityDate"]
        ? fieldsValue["activityDate"].format(dateFormat)
        : null,
    };
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const propertiesRef = collection(companyDocRef, "activities");

    const proActivities = query(propertiesRef, where("propertyId", "==", id));

    const querySnapshot = await getDocs(proActivities);

    const newPropertyActivity = {
      assignTo: values.assignTo || "",
      allDay: values.allDay || false,
      activityDate: values.activityDate || "",
      activityTime: values.activityTime || "",
      activityTimeOfDay: values.activityTimeOfDay || "",
      Description: values.Description,
      activityLabel: values.activityLabel || "",
      activityStatus: values.activityStatus || "",
    };

    if (querySnapshot.empty) {
      // No matching documents.
      console.log("No matching documents.");
      try {
        await addDoc(propertiesRef, {
          propertiesActivities: [newPropertyActivity],
          propertyId: id,
        });
        toast.success("Activity Added successfully!");
        navigate(`/property-tabs/property/${id}`);
      } catch (err) {
        toast.error("Something went wrong!");
        console.error(err);
        setIsWait(false);
      }
    } else {
      console.log("Matching documents found.");
      querySnapshot.forEach(async (d) => {
        try {
          const docRef = doc(propertiesRef, d.id);
          await updateDoc(docRef, {
            propertiesActivities: arrayUnion(newPropertyActivity),
          });
          toast.success("Activity Added successfully!");
          navigate(`/property-tabs/property/${id}`);
        } catch (err) {
          toast.error("Something went wrong!");
          console.error(err);
        }
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    toast.error("Please Fill the required filed!");
  };
  console.log("OK");
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    const fetchData = async () => {
      if (editParam >= 0) {
        try {
          const companiesRef = collection(db, "companies");
          const companyDocRef = doc(companiesRef, companyName);
          const propertiesRef = collection(companyDocRef, "activities");
          const docRef = doc(propertiesRef, id);
          const docSnapshot = await getDoc(docRef);
          const propertyNames = Object.keys(
            docSnapshot.data()?.propertiesActivities || {}
          );
          const activityData =
            docSnapshot?.data()?.propertiesActivities?.[`activity${editParam}`];

          if (activityData) {
            setActivityData(activityData);
          }

          setLoadForm(true);
        } catch (error) {
          console.error(error);
        }
      } else {
        setLoadForm(true);
      }
    };
    if (companyName.length > 0) {
      fetchData();
    }

    console.log("useEffect.....");
  }, [companyName]);

  const [propertyName, setPropertyName] = useState("");

  const fetchPropertyById = async (companyName) => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", id);
      const propertyDocSnapshot = await getDoc(propertyDocRef);

      if (propertyDocSnapshot.exists()) {
        const propertyData = propertyDocSnapshot.data();
        setPropertyName(propertyData.propertyNameAddress.propertyName);
        // Process the property or update state as needed
      } else {
        console.log("Property does not exist");
      }
    } catch (error) {
      console.log("Error getting property:", error);
    }
  };

  useEffect(() => {
    if (companyName) {
      fetchPropertyById(companyName);
    }
  }, [companyName]);

  const defaultValues = {
    // activityDate: dayjs(activityData?.activityDate, dateFormat) ?? "",
    Description: activityData?.Description ?? "",
    activityLabel: activityData?.activityLabel ?? "",
    activityStatus: activityData?.activityStatus ?? "",
    activityTime: activityData?.activityTime ?? "",
    activityTimeOfDay: activityData?.activityTimeOfDay ?? "",
    allDay: activityData?.allDay ?? false,
    assignTo: activityData?.assignTo ?? "",
  };
  return (
    <div>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="New Activity" />
          <p>
            <b>Property: </b>
            <Link to={`/property-tabs/property/${id}`}>{propertyName}</Link>
          </p>
          <br />
          <Form
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            name="basic"
            autoComplete="off"
            layout="vertical"
            initialValues={defaultValues}
          >
            <Form.Item
              label="Date"
              name="activityDate"
              rules={[{ required: true, message: "Please select a date" }]}
            >
              <DatePicker format={dateFormat} placeholder="" />
            </Form.Item>

            <Form.Item name="allDay" valuePropName="checked">
              <Checkbox> All Day</Checkbox>
            </Form.Item>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Time" name={"activityTime"}>
                  <Input placeholder="HH:MM" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="AM/PM" name={"activityTimeOfDay"}>
                  <Select
                    options={[
                      {
                        value: "AM",
                        label: "AM",
                      },
                      {
                        value: "PM",
                        label: "PM",
                      },
                    ]}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={20}>
                <Form.Item
                  label="Description"
                  name="Description"
                  rules={[
                    {
                      required: true,
                      message: "Please add some description.",
                    },
                  ]}
                >
                  <TextArea
                    showCount
                    placeholder="e.g. Send Rent Increase Reminder"
                    maxLength={250}
                    style={{
                      height: 10,
                      resize: "none",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8}>
                <Form.Item label="Label" name={"activityLabel"}>
                  <Select
                    allowClear
                    showSearch
                    placeholder="Type to search or add new"
                    options={[
                      {
                        value: "section 8",
                        label: "section 8",
                      },
                      {
                        value: "Workflow",
                        label: "Workflow",
                      },
                    ]}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8}>
                <Form.Item label="Assign To" name={"assignTo"}>
                  <Select
                    allowClear
                    showSearch
                    placeholder="Start typing to search"
                    options={allUsersData}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8}>
                <Form.Item label="Status" name={"activityStatus"}>
                  <Select
                    options={[
                      {
                        value: "Pending",
                        label: "Pending",
                      },
                      {
                        value: "Queued",
                        label: "Queued",
                      },
                      {
                        value: "In Progress",
                        label: "In Progress",
                      },
                      {
                        value: "Completed",
                        label: "Completed",
                      },
                    ]}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Row gutter={16}>
                <Col>
                  <Button type="primary" htmlType="submit" loading={isWait} >
                    {/* onClick={handleNewActivity} */}
                    {isWait ? "Please wait..." : "Save"}
                  </Button>
                </Col>
                <Col>
                  <Button onClick={handleNewActivity}>Cancel</Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
          <Footer />
        </div>
      </div>

      <div className="RightSidebar"></div>
    </div>
  );
};

export default NewActivity;
